import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBank,
  faCreditCard,
  faHandHoldingHeart,
  faMoneyBillTransfer,
  faMoneyCheck,
  faWallet,
} from '@fortawesome/free-solid-svg-icons'
import { faApple } from '@fortawesome/free-brands-svg-icons'

import LOGOS from 'src/payments/logos'

const PaymentOptionIcon = ({ option, paymentOptions }) => {
  switch (option) {
  case 'credit_card': return (
    <FontAwesomeIcon
      icon={faCreditCard}
      className="mt-1 mt-sm-0 me-sm-2"
      style={{ color: 'var(--bs-blue)' }}
    />
  )
  case 'bank': return (
    <FontAwesomeIcon
      icon={faBank}
      className="mt-1 mt-sm-0 me-sm-2"
      style={{ color: 'var(--bs-teal)' }}
    />
  )
  case 'paypal': return (
    <span className="mt-1 mt-sm-0 me-sm-2 d-inline-block svg-inline--fa">
      <img
        src={LOGOS.paypal}
        className="d-block"
        style={{ width: '0.8122em', height: '1em' }}
        aria-hidden="true"
      />
    </span>
  )
  case 'venmo': return (
    <span
      className="mt-1 mt-sm-0 me-sm-2 d-inline-block svg-inline--fa"
      style={{ overflow: 'hidden', borderRadius: '0.2em' }}
    >
      <img
        src={LOGOS.venmo}
        className="d-block"
        style={{ width: '1em', height: '1em' }}
        aria-hidden="true"
      />
    </span>
  )
  case 'check': return (
    <FontAwesomeIcon
      icon={faMoneyCheck}
      className="mt-1 mt-sm-0 me-sm-2"
      style={{ color: 'var(--bs-blue)' }}
    />
  )
  case 'wire': return (
    <FontAwesomeIcon
      icon={faMoneyBillTransfer}
      className="mt-1 mt-sm-0 me-sm-2"
      style={{ color: 'var(--bs-teal)' }}
    />
  )
  case 'tbd': return (
    <FontAwesomeIcon
      icon={faHandHoldingHeart}
      className="mt-1 mt-sm-0 me-sm-2"
      style={{ color: 'var(--bs-purple)' }}
    />
  )
  case 'paymentRequest':
    switch (paymentOptions?.paymentRequest) {
    case 'Apple Pay': return (
      <FontAwesomeIcon
        icon={faApple}
        className="mt-1 mt-sm-0 me-sm-2"
        style={{ color: '#000' }}
      />
    )
    case 'Google Pay': return (
      <span className="mt-1 mt-sm-0 me-sm-2 d-inline-block svg-inline--fa">
        <img
          src={LOGOS.google_pay}
          className="d-block"
          style={{ width: '1em', height: '1em' }}
          aria-hidden="true"
        />
      </span>
    )
    default: return (
      <FontAwesomeIcon
        icon={faWallet}
        className="mt-1 mt-sm-0 me-sm-2"
      />
    )
    }
  }
}

export default PaymentOptionIcon
